import {Box} from '@mui/material';
import ArrFilterChip from '../../../components/common/arr-filter-chip/ArrFilterChip';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import '../Demo.scss';

const FilterChipDemo = () => {
  return (
    <Box sx={{marginLeft: 4}}>
      <h1>ARR Filter Chip</h1>
      <ArrFilterChip
        filterName=""
        selections={[{id: 1, value: 'FilterSelection'}]}
        variant="v1"
        operator="OR"
        isResponsive={false}
      />
      &nbsp;
      <ArrFilterChip
        filterName=""
        selections={[
          {id: 1, value: 'FilterSelection'},
          {id: 2, value: 'FilterSelection'},
        ]}
        variant="v1"
        operator="OR"
        isResponsive={false}
      />
      &nbsp;
      <ArrFilterChip
        filterName=""
        selections={[
          {id: 1, value: 'FilterSelection'},
          {id: 2, value: 'FilterSelection'},
          {id: 3, value: 'FilterSelection'},
        ]}
        operator="OR"
        variant="v1"
        isResponsive={false}
      />
      &nbsp;
      <ArrFilterChip
        filterName="FilterName"
        selections={[{id: 1, value: 'FilterSelection'}]}
        variant="v1"
        operator="OR"
        isResponsive={false}
      />
      &nbsp;
      <ArrFilterChip
        filterName="FilterName"
        selections={[
          {id: 1, value: 'FilterSelection'},
          {id: 2, value: 'FilterSelection'},
        ]}
        variant="v1"
        operator="OR"
        isResponsive={false}
      />
      &nbsp;
      <ArrFilterChip
        filterName="FilterName"
        selections={[
          {id: 1, value: 'FilterSelection'},
          {id: 2, value: 'FilterSelection1'},
          {id: 3, value: 'FilterSelection2'},
          {id: 4, value: 'FilterSelection3'},
        ]}
        operator="AND"
        variant="v1"
        operatorVariant="v2"
        classNames="chip-v1"
        onRemoveSelection={(selectionId) =>
          console.log('Removed Id', selectionId)
        }
        isResponsive={false}
      />
      &nbsp;
      <ArrFilterChip
        filterName=""
        selections={[{id: 1, value: 'FilterSelection'}]}
        operator="OR"
        variant="v1"
        isResponsive={false}
        icon={<ManageSearchIcon />}
      />
      &nbsp;
      <ArrFilterChip
        filterName="FilterName"
        selections={[{id: 1, value: 'FilterSelection'}]}
        operator="OR"
        variant="v1"
        isResponsive={false}
        icon={<ManageSearchIcon />}
      />
      &nbsp;
      <Box sx={{marginBottom: 2}}>
        <ArrFilterChip
          filterName="FilterName"
          selections={[
            {id: 1, value: 'FilterSelection'},
            {id: 2, value: 'FilterSelection'},
            {id: 3, value: 'FilterSelection'},
            {id: 4, value: 'FilterSelection'},
          ]}
          operator="OR"
          variant="v1"
          isResponsive={true}
        />
      </Box>
      <Box sx={{marginBottom: 2}}>
        <ArrFilterChip
          filterName="FilterName"
          selections={[
            {id: 1, value: 'FilterSelection'},
            {id: 2, value: 'FilterSelection'},
            {id: 3, value: 'FilterSelection'},
            {id: 4, value: 'FilterSelection'},
          ]}
          variant="v1"
          isResponsive={true}
        />
      </Box>
      <Box sx={{marginBottom: 2}}>
        <ArrFilterChip
          filterName={['Label1', 'Label2']}
          selections={[
            {id: 1, value: 'Selection1'},
            {id: 2, value: 'Selection2'},
            {id: 3, value: 'Selection3'},
            {id: 4, value: 'Selection4'},
          ]}
          variant="v2"
          isResponsive={false}
        />
      </Box>
      <Box sx={{marginBottom: 2}}>
        <ArrFilterChip
          filterName={['Label1', 'Label2']}
          selections={[
            {id: 1, value: 'Selection1'},
            {id: 2, value: 'Selection2'},
            {id: 3, value: 'Selection3'},
            {id: 4, value: 'Selection4'},
          ]}
          variant="v2"
          classNames="chip-v2"
          isResponsive={false}
        />
      </Box>
    </Box>
  );
};

export default FilterChipDemo;
